interface MockUser {
  email: string
  password: string
}

// ローカルストレージのキー
const MOCK_USER_KEY = "mock_user"
const MOCK_AUTH_KEY = "mock_auth"

// モックユーザーを保存
export function saveMockUser(email: string, password: string): void {
  const user: MockUser = { email, password }
  localStorage.setItem(MOCK_USER_KEY, JSON.stringify(user))
}

// モックユーザーを取得
export function getMockUser(): MockUser | null {
  const userJson = localStorage.getItem(MOCK_USER_KEY)
  if (!userJson) return null

  try {
    return JSON.parse(userJson) as MockUser
  } catch (error) {
    console.error("Failed to parse mock user:", error)
    return null
  }
}

// モック認証状態を保存
export function setMockAuthState(isAuthenticated: boolean, email?: string): void {
  localStorage.setItem(MOCK_AUTH_KEY, JSON.stringify({ isAuthenticated, email }))
}

// モック認証状態を取得
export function getMockAuthState(): { isAuthenticated: boolean; email: string | null } {
  const authJson = localStorage.getItem(MOCK_AUTH_KEY)
  if (!authJson) return { isAuthenticated: false, email: null }

  try {
    return JSON.parse(authJson) as { isAuthenticated: boolean; email: string | null }
  } catch (error) {
    console.error("Failed to parse mock auth state:", error)
    return { isAuthenticated: false, email: null }
  }
}

// モックログイン
export function mockSignIn(email: string, password: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const user = getMockUser()

      if (!user) {
        // 初回ログイン時はユーザーが存在しないので、自動的に登録する
        saveMockUser(email, password)
        setMockAuthState(true, email)
        resolve(true)
        return
      }

      if (user.email === email && user.password === password) {
        setMockAuthState(true, email)
        resolve(true)
      } else {
        reject(new Error("Invalid email or password"))
      }
    }, 500) // 実際のAPIリクエストを模倣するための遅延
  })
}

// モックサインアップ
export function mockSignUp(email: string, password: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // 既存ユーザーチェック
      const existingUser = getMockUser()
      if (existingUser && existingUser.email === email) {
        reject(new Error("User already exists"))
        return
      }

      // 新規ユーザー登録
      saveMockUser(email, password)
      resolve(true)
    }, 500) // 実際のAPIリクエストを模倣するための遅延
  })
}

// モックログアウト
export function mockSignOut(): void {
  setMockAuthState(false)
}

// モック認証チェック
export function mockIsAuthenticated(): Promise<boolean> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const { isAuthenticated } = getMockAuthState()
      resolve(isAuthenticated)
    }, 100)
  })
}

// モックユーザー情報取得
export function mockGetUserInfo(): Promise<{ email: string } | null> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const { isAuthenticated, email } = getMockAuthState()
      if (isAuthenticated && email) {
        resolve({ email })
      } else {
        resolve(null)
      }
    }, 100)
  })
}
